module.exports = {
    da: {
        in: 'ind',
        min: 'min',
        out: 'ud',
        'title.assist': 'ASSIST',
        'title.goal': 'MÅL',
        'title.owngoal': 'SELVMÅL',
        'title.red_card': 'RØDT KORT',
        'title.subs': 'UDSKIFTNING',
        'title.yellow_card': 'GULT KORT',
    },
    de: {
        in: 'in',
        min: 'min',
        out: 'aus',
        'title.assist': 'ASSIST',
        'title.goal': 'TOR',
        'title.owngoal': 'EIGENTOR',
        'title.red_card': 'ROTE KARTE',
        'title.subs': 'AUSWECHSLUNG',
        'title.yellow_card': 'GELBE KARTE',
    },
    en: {
        in: 'in',
        min: 'min',
        out: 'out',
        'title.assist': 'ASSIST',
        'title.goal': 'GOAL',
        'title.owngoal': 'OWN GOAL',
        'title.red_card': 'RED CARD',
        'title.subs': 'SUBSTITUTION',
        'title.yellow_card': 'YELLOW CARD',
    },
    fi: {
        in: 'sisään',
        min: 'min',
        out: 'ulos',
        'title.assist': 'SYÖTTÖ',
        'title.goal': 'MAALI',
        'title.owngoal': 'OMA MAALI',
        'title.red_card': 'PUNAINEN KORTTI',
        'title.subs': 'VAIHTO',
        'title.yellow_card': 'KELTAINEN KORTTI',
    },
    no: {},
    sc: {},
    se: {
        in: 'i',
        min: 'min',
        out: 'ut',
        'title.assist': 'ASSIST',
        'title.goal': 'MÅL',
        'title.owngoal': 'SJÄLVMÅL',
        'title.red_card': 'RÖTT KORT',
        'title.subs': 'BYTE',
        'title.yellow_card': 'GULT KORT',
    },
    th: {},
};



/** WEBPACK FOOTER **
 ** ../src/widgets/i18/i18.IncidentWidget.js
 **/